// Locale-aware date format maps.
// Keys match BCP 47 language tags stored in workspace.config.locale.
// All formats use moment.js / dayjs token syntax.
// READABLE_DATE_TIME_FORMAT_DATEFNS uses date-fns tokens (react-datepicker).

export const DATE_FORMATS = {
  "en-AU": {
    short: "DD/MM/YYYY",
    shortDateTime: "DD/MM/YYYY HH:mm:ss",
    readable: "DD MMM YYYY",
    readableDateTime: "hh:mma DD MMM YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "DD\u00A0MMM\u00A0YYYY",
    dateFns: "hh:mma dd MMM yyyy",
  },
  "en-GB": {
    short: "DD/MM/YYYY",
    shortDateTime: "DD/MM/YYYY HH:mm:ss",
    readable: "DD MMM YYYY",
    readableDateTime: "hh:mma DD MMM YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "DD\u00A0MMM\u00A0YYYY",
    dateFns: "hh:mma dd MMM yyyy",
  },
  "en-US": {
    short: "MM/DD/YYYY",
    shortDateTime: "MM/DD/YYYY HH:mm:ss",
    readable: "MMM DD, YYYY",
    readableDateTime: "hh:mma MMM DD, YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "MMM\u00A0DD,\u00A0YYYY",
    dateFns: "hh:mma MMM dd, yyyy",
  },
};

export const DEFAULT_LOCALE = "en-AU";

export const getDateFormats = (locale) =>
  DATE_FORMATS[locale] || DATE_FORMATS[DEFAULT_LOCALE];
